import { Classification } from "../classification";

export type UserWithoutTeachers = {
    id: number;
    email: string;
    phone_number: string;
    first_name: string;
    last_name: string;
    main_subject: Classification | null;
    additional_subjects: Classification[];
    main_goal: Classification | null;
    classes: Classification[];
    image: File | string | null;
    is_app_admin: boolean;
    is_app_developer: boolean;
    is_active: boolean;
    last_seen_at: Date | null;
    last_login: Date | null;
    login_count: number;
    created_at: Date;
    updated_at: Date;
};

export const getFullName = (user: UserWithoutTeachers) => {
    return `${user.first_name} ${user.last_name}`;
};
